import * as monaco from 'monaco-editor/esm/vs/editor/editor.api.js';
(window as any).monaco = monaco;
import { TXILanguageService } from "@/apps/forge/states/TXILanguageService";
import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import "@/apps/forge/app.scss";
import { AppProvider, useApp } from "@/apps/forge/context/AppContext";
import * as KotOR from "@/apps/forge/KotOR";
import { App } from "@/apps/forge/App";
import { Launcher } from "@/apps/launcher/context/Launcher";
import { applyProfileSeo } from "@/apps/common/seo/applyProfileSeo";
import { buildProfileSeo } from "@/apps/common/seo/profileSeo";
import { applyForgeTheme } from "@/apps/forge/settings/forgeTheme";
import { restoreGameDirectoryHandlesToProfiles } from "@/utility/gameDirectoryAccess";

TXILanguageService.initTXILanguage();

const query = new URLSearchParams(window.location.search);

switch(query.get('key')){ 
  case 'kotor':
  case 'tsl':

  break;
  default:
    query.set('key', 'kotor');
  break;
}

const loadReactApplication = () => {
  const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
  ( async () => {
    root.render(
      // <React.StrictMode>
        <AppProvider>
          <App />
        </AppProvider>
      // </React.StrictMode>
    );
  })();
}

( async () => {
  await KotOR.ConfigClient.Init();
  await Launcher.InitProfiles();
  await restoreGameDirectoryHandlesToProfiles();
  const getProfile = () => {
    const rawKey = query.get("key");
    const key =
      rawKey && ['kotor', 'tsl'].includes(rawKey) ? rawKey : "kotor";
    return Launcher.GetProfileByKey(key);
  };

  const profileKey = query.get("key") && ['kotor', 'tsl'].includes(query.get("key")!) ? query.get("key")! : "kotor";

  const profile = getProfile();
  if (!profile) {
    throw new Error('Failed to load Forge profile context');
  }

  KotOR.ApplicationProfile.SetProfile(profile);
  KotOR.ApplicationProfile.InitEnvironment();

  applyProfileSeo(buildProfileSeo(profile, {
    appPath: '/forge/',
    profileKey,
  }));

  document.documentElement.classList.add(KotOR.ApplicationProfile.GameKey);
  document.body.classList.add(KotOR.ApplicationProfile.GameKey);
  applyForgeTheme();
  loadReactApplication();
})();

const plChangeCallback = (e: any) => {
  // document.pointerLockElement = this.element;
  // console.log('ModelViewerControls', e);
  if(document.pointerLockElement instanceof HTMLCanvasElement) {
    //console.log('The pointer lock status is now locked');
    document.body.addEventListener("mousemove", plMouseMove, true);
    KotOR.Mouse.Dragging = true;
  } else {
    //console.log('The pointer lock status is now unlocked');
    document.body.removeEventListener("mousemove", plMouseMove, true);
    //this.plMoveEvent = undefined;
    KotOR.Mouse.Dragging = false;
    //document.removeEventListener('pointerlockchange', this.plEvent, true);
  }
}

const plMouseMove = (event: any) => {
  if(KotOR.Mouse.Dragging && (event.movementX || event.movementY)){
    let range = 1000;
    //console.log(event.movementX, event.movementY);
    if(event.movementX > -range && event.movementX < range){
      KotOR.Mouse.OffsetX = event.movementX || 0;
    }else{console.log('x', event.movementX)}
    if(event.movementY > -range && event.movementY < range){
      KotOR.Mouse.OffsetY = (event.movementY || 0)*-1.0;
    }else{console.log('y', event.movementY)}
  }
}

document.addEventListener('pointerlockchange', plChangeCallback, true);
document.addEventListener('pointerlockerror', (e) => {
  console.error(e);
}, true);
